<template>
    <div class="px-sm-0 mt-sm-5 mt-3">
        <section v-if="field.box" class="section home-section bg white">
            <div class="inner-wrap container pt-4 pb-4">
                <div class="row d-block">
                    <div class="content p-lg-3 py-1 px-2">
                        <h2 class="text-center ui header big-xl large-md medium color gray-4">{{field.data ? field.data.title : 'Title' }}</h2>
                        <p class="text-center ui text light huge-xl large-md medium color gray-9">{{field.data ? field.data.detail : 'Detail ...' }}</p>
                    </div>
                </div>
            </div>
        </section>
        <section v-else class="section home-section">
            <div class="inner-wrap container">
                <div class="row d-block">
                    <div class="content m-lg-3 mt-lg-5 mt-5">
                        <h2 class="text-center ui header big-xl large-md medium-sm tiny color gray-4">{{field.data ? field.data.title : 'Title' }}</h2>
                        <p class="text-center ui text light huge-xl big-md medium-sm tiny color gray-9">{{field.data ? field.data.detail : 'Detail ...' }}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>


export default {
    name: 'sectiontitle',
    components:{
    },
    props:{
        field: {
            type: Object,
            default: {
                box: true
            }
        },
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        
    }
}
</script>